"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.FooterEntity = void 0;
var utils_1 = require("@lglp/utils");
var types_1 = require("../../../types");
var slices_1 = require("../../slices");
var entity_factory_1 = require("../entity-factory");
var slices_2 = require("./slices");
var processCardSlices = function (prismicSlices, logger) {
    var slices = slices_1.processSlices({
        simpleCardContainer: slices_2.simpleCardContainer,
        multipleCardsContainer: slices_2.multipleCardsContainer,
        iconCardsContainer: slices_2.iconCardsContainer
    }, prismicSlices, logger);
    return slices === null || slices === void 0 ? void 0 : slices[0];
};
exports.FooterEntity = entity_factory_1.entityFactory(types_1.DocumentType.FOOTER, function (prismicDoc, normalizedEntity, logger) {
    var _a, _b, _c, _d;
    return utils_1.compact(__assign(__assign({}, normalizedEntity), { uid: types_1.DocumentType.FOOTER, type: types_1.DocumentType.FOOTER, menu: slices_1.processSlices({
            footerLink: slices_2.footerLink,
            rgpdLink: slices_2.rgpdLink
        }, (_a = prismicDoc === null || prismicDoc === void 0 ? void 0 : prismicDoc.data) === null || _a === void 0 ? void 0 : _a.menu_items, logger), cards: {
            left: logger.required(processCardSlices((_b = prismicDoc === null || prismicDoc === void 0 ? void 0 : prismicDoc.data) === null || _b === void 0 ? void 0 : _b.left_content, logger)),
            right: logger.required(processCardSlices((_c = prismicDoc === null || prismicDoc === void 0 ? void 0 : prismicDoc.data) === null || _c === void 0 ? void 0 : _c.right_content, logger))
        }, socialNetworks: slices_1.processSlices({
            Facebook: slices_2.socialNetwork(types_1.SocialLinkTypes.FACEBOOK),
            Instagram: slices_2.socialNetwork(types_1.SocialLinkTypes.INSTAGRAM),
            LinkedIn: slices_2.socialNetwork(types_1.SocialLinkTypes.LINKEDIN),
            Twitter: slices_2.socialNetwork(types_1.SocialLinkTypes.TWITTER),
            Youtube: slices_2.socialNetwork(types_1.SocialLinkTypes.YOUTUBE)
        }, (_d = prismicDoc === null || prismicDoc === void 0 ? void 0 : prismicDoc.data) === null || _d === void 0 ? void 0 : _d.socialnetworks_list, logger) }));
});
//# sourceMappingURL=footer.js.map